import React from "react"
import { useSelector } from "react-redux"

import { PUBLISHED, UNPUBLISHED } from "const"
import { StoreType, CcLibrarySetFilters } from "client/store"
import { PublishedUnpublished } from "client/utils"
import {
    SearchBar,
    SearchFilter,
} from "client/components"

interface SearchLibrarySet {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: CcLibrarySetFilters
    onFilter: (filters: CcLibrarySetFilters) => void
}

const statusArray = [PUBLISHED, UNPUBLISHED]

const CcLibrarySetSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchLibrarySet) => {
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)

    const popupFilters: SearchFilter[] = []

    if (userData.accountId !== 1) {
        popupFilters.push(
            {
                title: lang.imported,
                isActive: filters.imported,
                onAdd: (obj: CcLibrarySetFilters) => ({
                    ...obj,
                    imported: true,
                    created: false,
                }),
                onClose: (obj: CcLibrarySetFilters) => ({
                    ...obj,
                    imported: false,
                }),
            },
            {
                title: lang.created,
                isActive: filters.created,
                onAdd: (obj: CcLibrarySetFilters) => ({
                    ...obj,
                    created: true,
                    imported: false,
                }),
                onClose: (obj: CcLibrarySetFilters) => ({
                    ...obj,
                    created: false,
                }),
            },
        )
    }

    statusArray.forEach((status: PublishedUnpublished) => {
        popupFilters.push({
            title: lang[status],
            isActive: filters.status === status,
            onAdd: (obj: CcLibrarySetFilters) => ({
                ...obj,
                status,
            }),
            onClose: (obj: CcLibrarySetFilters) => ({
                ...obj,
                status: null,
            }),
        })
    })

    return (
        <SearchBar
            id={id}
            filters={filters}
            leftOffset={leftOffset}
            rightOffset={rightOffset}
            popupFilters={popupFilters}
            onFilter={onFilter}
        />
    )
}
export default CcLibrarySetSearch
